import Slider from 'react-slick';   
import  './FleetFiveSlide.css';
const PrevArrow = (props) => (
  <button {...props} className="slick-prev">
    <img src="/img/rentshield/claims_arrow_left.svg" alt="Previous" width="48" height="48" />
  </button>
);

const NextArrow = (props) => (
  <button {...props} className="slick-next">
    <img src="/img/rentshield/claims_arrow_right.svg" alt="Next" width="48" height="48" />
  </button>
);


const FleetFiveSlide = ()=>{

// START cards
  // const cards = [
  //   { 
  //     id: 1, 
  //     image: '/img/Fleet/security_pink.svg',
  //     heading: 'One-Car Fleet Coverage', 
  //     text: 'Rentid insures fleets starting with just one vehicle, lowering barriers to entry and helping you fleet and defleet with ease.' 
  //   },
  //   { 
  //     id: 2, 
  //     image: '/img/Fleet/analytics_pink.svg',
  //     heading: 'Maximized Profitability', 
  //     text: 'No trip or commission fees means more profit in your pocket. You’re control of revenue while Rentid streamlines bookings and payments,' 
  //   },
  //   { 
  //     id: 3, 
  //     image: '/img/Fleet/flow_pink.svg',
  //     heading: 'Operational Efficiency Through Automation', 
  //     text: 'Our automated rental platform means less time managing tedious tasks and more time to increase revenue.' 
  //   },
  //   { 
  //     id: 4, 
  //     image: '/img/Fleet/badge_pink.svg',
  //     heading: 'Risk Mitigation for Every Trip', 
  //     text: 'ID, insurance verification, along with  DriverIQ™ scoring safeguards your business by vetting renters and keeping your assets on the road.' 
  //   },
  //   { 
  //     id: 5, 
  //     image: '/img/Fleet/menu_pink.svg',
  //     heading: 'Scalable Fleet Management', 
  //     text: 'Adjust pricing, track vehicle availability, and manage rental agreements via a centralized dashboard.' 
  //   },
  //   { 
  //     id: 6, 
  //     image: '/img/Fleet/union_pink.svg',
  //     heading: 'AI-Powered Task Support ', 
  //     text: 'Smart automation handles customer interactions, reducing administrative burdens.' 
  //   },

  //  ];
// END cards

// START slick
const settings = {
  slidesToShow: 5,
  slidesToScroll: 1,
  margin: 30,
  autoplay: true,
  autoplaySpeed: 2000,

  // autoplaySpeed: 0,  // No delay between scrolls
  // speed: 4000,  // Smooth continuous movement
  // cssEase: 'linear',

  loop: true,
  dots: false,
  arrows: false,
  focusOnSelect: true,
  centerPadding: '30px',
  prevArrow: <PrevArrow />,
  nextArrow: <NextArrow />,
  responsive: [
    {
      breakpoint: 1480,
      settings: {
        slidesToShow: 4, // Correcting the key to 'slidesToShow'
        infinite: true,
        centerPadding: "30px",
        margin: 30,
      },
    },
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 4, // Correcting the key to 'slidesToShow'
        infinite: true,
        centerPadding: "30px",
        margin: 30,
      },
    },
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 3, // Correcting the key to 'slidesToShow'
        infinite: true,
        margin: 30,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3, // Correcting the key to 'slidesToShow'
        margin: 20,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2, // Correcting the key to 'slidesToShow'
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2, // Correcting the key to 'slidesToShow'
      },
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 2, // Correcting the key to 'slidesToShow'
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1, // Correcting the key to 'slidesToShow'
        centerPadding: "30px",
      },
    },
  ],
};
// END slick

    return(
        <>
            {/* START fleetFiveSliderMain */}
            <section className="fleetFiveSliderMain">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <div className="fleetFiveSliderHead">
                                <h2>6 Reasons Why Emerging<br/> Fleets Choose Rentid</h2>
                                <p>Starting out made simple</p>
                            </div>
                        </div>
                    </div>
                  </div>

                  <div className='row justify-content-center'>
                    <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                        <Slider {...settings}>  
                            <div className="item">
                              <div className="fleetFiveSliderDetail">
                                <img className="img-fluid" src="/img/Fleet/security_pink.svg" alt="One-Car Fleet Coverage" />
                                <h3>One-Car<br/> Fleet Coverage</h3>
                                <p>Rentid insures fleets starting with<br/> just one vehicle, lowering barriers to<br/> entry and helping you fleet and<br/> defleet with ease.</p>
                              </div>
                            </div>
                          
                            <div className="item">
                              <div className="fleetFiveSliderDetail">
                                <img className="img-fluid" src="/img/Fleet/analytics_pink.svg" alt="Maximized Profitability" />
                                <h3>Maximized<br/> Profitability</h3>
                                <p>No trip or commission fees means<br/> more profit in your pocket. You’re<br/> control of revenue while Rentid<br/> streamlines bookings and payments,</p>
                              </div>
                            </div>

                            <div className="item">
                              <div className="fleetFiveSliderDetail">
                                <img className="img-fluid" src="/img/Fleet/flow_pink.svg" alt="Operational Efficiency Through Automation" />
                                <h3>Operational Efficiency<br/> Through Automation</h3>
                                <p>Our automated rental platform means<br/> less time managing tedious tasks and<br/> more time to increase revenue.</p>
                              </div>
                            </div>

                            <div className="item">
                              <div className="fleetFiveSliderDetail">
                                <img className="img-fluid" src="/img/Fleet/badge_pink.svg" alt="Risk Mitigation for Every Trip" />
                                <h3>Risk Mitigation<br/> for Every Trip</h3>
                                <p>ID, insurance verification, along with<br/> DriverIQ™ scoring safeguards your<br/> business by vetting renters and<br/> keeping your assets on the road.</p>
                              </div>
                            </div>
                            
                            <div className="item">
                              <div className="fleetFiveSliderDetail">
                                <img className="img-fluid" src="/img/Fleet/menu_pink.svg" alt="Scalable Fleet Management" />
                                <h3>Scalable Fleet<br/> Management</h3>
                                <p>Adjust pricing, track vehicle<br/> availability, and manage rental<br/> agreements via a centralized<br/> dashboard.</p>
                              </div>
                            </div>
                            
                            <div className="item">
                              <div className="fleetFiveSliderDetail">
                                <img className="img-fluid" src="/img/Fleet/union_pink.svg" alt="AI-Powered Task Support " />
                                <h3>AI-Powered<br/> Task Support</h3>
                                <p>Smart automation handles customer<br/> interactions, reducing administrative<br/> burdens.</p>
                              </div>
                            </div>
                  

                        </Slider> 
      
                    </div>
                  </div>  
                  
                  {/* <div className="fleetFiveSlider">
                      <div className="carousel-container mt-2">
                          <div className="carousel">
                                <div className="carousel-track">
                                  {cards.map((card) => (
                                    <div key={card.id} className="fleetFiveSliderDetail">
                                      <img src={card.image} alt={card.heading1} className="img-fluid" />
                                      <h3>{card.heading}</h3>
                                      <p>{card.text}</p>
                                    </div>
                                  ))}
                                </div>
                                <div className="carousel-track">
                                  {cards.map((card) => (
                                    <div key={`duplicate-${card.id}`} className="fleetFiveSliderDetail">
                                      <img src={card.image} alt={card.heading1} className="img-fluid" />
                                      <h3>{card.heading}</h3>
                                      <p>{card.text}</p>
                                    </div>
                                  ))}
                                </div>
                          </div>
                      </div>
                  </div> */}
            </section>
            {/* END fleetFiveSliderMain */}
        </>
    )
}

export default FleetFiveSlide;